import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import useMentoringInvite from "./hooks/useMentoringInvite";
import MentoringInviteView from "./view";

/**
 * Public mentoring invite controller (§6.9). Route: mentoring/invite/:token —
 * rendered by App.js's public branch, OUTSIDE the app shell and without the auth
 * redirect (§10). Reads the token, runs the invite hook, and renders the view.
 * No breadcrumb / ScreenContext here: there is no surrounding shell to publish to.
 */
export default function MentoringInvite() {
  const { token } = useParams();
  const { t } = useTranslation("member");
  const invite = useMentoringInvite(token);

  const programName = invite.program?.name;

  useEffect(() => {
    document.title = programName
      ? t("invite.documentTitleProgram", { name: programName })
      : t("invite.documentTitle");
  }, [programName, t]);

  return <MentoringInviteView {...invite} />;
}
